import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { AmlHit } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import AmlHitItem from '../aml-hit-item';
type AmlHitsListProps = {
  hits: AmlHit[];
  shareUrl?: string;
};
const AmlHitsList = t0 => {
  const $ = _c(9);
  const {
    hits,
    shareUrl
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.watchlist.amlList"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== shareUrl || $[2] !== t) {
    t2 = shareUrl && <LinkButton href={shareUrl} iconComponent={IcoArrowTopRight16} target="_blank">{t(_temp)}</LinkButton>;
    $[1] = shareUrl;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hits) {
    t3 = hits.map(_temp2);
    $[4] = hits;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-2">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default AmlHitsList;
function _temp($) {
  return $.readFullReport;
}
function _temp2(hit) {
  return <AmlHitItem key={JSON.stringify(hit)} hit={hit} />;
}